import { Controller, useFormContext } from 'react-hook-form';

const SelectField = ({
  name, label, options, placeholder,
}) => {
  const { control } = useFormContext();
  return (
    <div className="form-control">
      <label className="form-control__label">{label}</label>
      <Controller
        render={({ field }) => (
          <select
            {...field}
            placeholder={placeholder}
            className="from-control__select"
            data-testid={name}
          >
            {options.map((option) => (
              <option
                key={option.value}
                value={option.value}
              >
                {option.name}
              </option>
            ))}
          </select>
        )}
        control={control}
        name={name}
      />
    </div>
  );
};

export default SelectField;
